import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const KeyboardShortcuts = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isGuestMode } = useAuth();

  useEffect(() => {
    const handleKeyDown = (e) => {
      const tag = e.target.tagName;
      if (
        tag === 'INPUT' ||
        tag === 'TEXTAREA' ||
        tag === 'SELECT' ||
        e.target.isContentEditable ||
        e.target.closest('[role="dialog"]') ||
        e.target.closest('[role="listbox"]')
      ) return;

      if (!user && !isGuestMode) return;

      // Don't intercept browser/OS shortcuts
      if (e.metaKey || e.ctrlKey || e.altKey) return;

      switch (e.key) {
        case 'n':
        case 'N':
          e.preventDefault();
          navigate('/create');
          break;
        case '/': {
          e.preventDefault();
          const searchInput = document.querySelector('[data-testid="task-search-input"]') ||
            document.querySelector('[data-testid="search-input"]');
          if (searchInput) searchInput.focus();
          break;
        }
        case 'Escape': {
          const overlay = document.querySelector('.fixed.inset-0.z-40');
          if (overlay) overlay.click();
          break;
        }
        case 'h':
        case 'H':
          if (location.pathname !== '/hub') {
            e.preventDefault();
            navigate('/hub');
          }
          break;
        case 'c':
        case 'C':
          if (location.pathname !== '/calendar') {
            e.preventDefault();
            navigate('/calendar');
          }
          break;
        case 't':
        case 'T':
          if (location.pathname !== '/get-it-done') {
            e.preventDefault();
            navigate('/get-it-done');
          }
          break;
        case 'd':
        case 'D':
          if (location.pathname !== '/directory') {
            e.preventDefault();
            navigate('/directory');
          }
          break;
        case '?':
          // Could show a shortcut help modal in the future
          break;
        default:
          break;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [navigate, user, isGuestMode, location.pathname]);

  return null;
};

export default KeyboardShortcuts;
